"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2149],{

/***/ 139922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ LOCALES; }
/* harmony export */ });
var LOCALES = {
    ENGLISH: "en-US",
    SPANISH: "es"
};


/***/ }),

/***/ 708222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ OpendoorLogoBadge; },
/* harmony export */   "o": function() { return /* binding */ OpendoorLogo; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(135944);

var OpendoorLogo = function(param) {
    var _width = param.width, width = _width === void 0 ? "256px" : _width;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "256",
        height: "56",
        viewBox: "0 0 256 56",
        fill: "none",
        style: {
            height: "auto",
            maxWidth: "100%",
            width: width
        },
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
            d: "M154.378 38.5472L154.378 38.5473C153.466 38.9528 152.132 39.5455 150.289 39.5455C146.07 39.5455 143.85 36.6648 143.85 27.7977C143.85 18.4782 146.626 15.4851 150.622 15.4851C152.677 15.4851 154.009 16.671 154.952 17.857V38.3027C154.783 38.3671 154.592 38.452 154.378 38.5472ZM163.778 7.69108C163.778 4.7717 163.876 2.08934 163.928 0.988439C163.943 0.66633 163.674 0.407602 163.359 0.436253L155.364 1.36004C155.131 1.38131 154.952 1.57969 154.952 1.81802V9.72444C154.952 11.7574 155.063 13.8472 155.063 13.8472C153.898 13.5081 152.343 13.226 150.845 13.226C142.185 13.226 134.746 17.9139 134.746 29.6617C134.746 39.9406 140.13 44.0073 145.626 44.0073C149.512 44.0073 152.621 42.4258 155.008 40.3365H155.23L155.117 43.4538C155.104 43.7859 155.389 44.0485 155.712 44.0021L163.328 43.1369C163.586 43.1004 163.778 42.8756 163.778 42.6103V7.69108ZM18.6517 5.8832C24.7573 5.8832 26.9781 11.3616 26.9781 24.5776C26.9781 37.8501 24.3691 41.6346 18.8736 41.6346C12.6562 41.6346 10.5468 36.2122 10.5468 23.0531C10.5468 9.72376 13.2668 5.8832 18.6517 5.8832ZM18.985 3.51123C10.0471 3.51123 0 9.38472 0 24.239C0 37.7941 8.99286 44.0066 18.5399 44.0066C27.4778 44.0066 37.5249 38.302 37.5249 23.3352C37.5249 9.32872 28.5325 3.51123 18.985 3.51123ZM50.4951 39.7148C51.4948 40.9007 52.9932 41.7481 54.8808 41.7481C59.2661 41.7481 61.5978 39.3761 61.5978 29.04C61.5978 20.9634 59.2106 18.1396 54.9917 18.1396C53.0406 18.1396 51.7322 18.6632 50.8408 19.0199L50.8406 19.02L50.8402 19.0202C50.7175 19.0693 50.6026 19.1153 50.4951 19.1562V39.7148ZM50.4951 17.1233C52.8273 15.0899 55.9351 13.2263 59.8212 13.2263C65.0948 13.2263 70.7012 16.7843 70.7012 27.12C70.7012 38.8678 63.9291 44.0072 54.6589 44.0072C53.4933 44.0072 51.6612 43.7815 50.4401 43.4429C50.4401 43.4429 50.4951 44.9115 50.4951 46.888V52.0413V54.5539C50.4951 54.7879 50.3227 54.9845 50.0945 55.0106L42.1713 55.9213C41.9033 55.9522 41.6691 55.7386 41.6691 55.4646V52.0413V14.5686C41.6691 14.3346 41.8414 14.1379 42.0701 14.1115L49.7732 13.2255C50.0736 13.1907 50.3347 13.436 50.3249 13.7438L50.2178 17.1233H50.4951ZM82.7352 25.1992L92.2272 24.6908C92.2272 17.8571 91.3398 15.3718 88.0088 15.3718C85.1774 15.3718 82.957 18.0828 82.7352 25.1992ZM73.9646 28.5314C73.9646 18.704 81.1249 13.2256 88.4525 13.2256C96.0237 13.2256 100.775 17.0314 101.046 26.9886C101.051 27.1822 100.896 27.3454 100.705 27.3454H83.0837C82.8926 27.3454 82.7382 27.5086 82.7428 27.7027C82.9912 36.674 86.4173 39.1497 92.0608 39.1497C94.8154 39.1497 97.0362 38.4985 98.8947 37.6598C99.0317 37.5977 99.1904 37.6342 99.2881 37.7505L100.026 38.634C100.138 38.7672 100.136 38.9643 100.019 39.0911C97.9936 41.2638 93.8712 44.0069 88.4525 44.0069C78.7936 44.0069 73.9646 38.133 73.9646 28.5314ZM113.208 17.236C116.149 15.0902 119.813 13.2262 123.865 13.2262C128.584 13.2262 131.138 15.7114 131.138 20.7948V42.8819C131.138 43.1293 130.94 43.3294 130.697 43.3294H122.696C122.453 43.3294 122.256 43.1293 122.256 42.8819V22.9971C122.256 19.552 121.034 18.4789 118.426 18.4789C116.482 18.4789 114.484 18.9303 113.263 19.2129V42.8819C113.263 43.1293 113.065 43.3294 112.823 43.3294H104.876C104.634 43.3294 104.437 43.1293 104.437 42.8819V14.568C104.437 14.334 104.609 14.1378 104.838 14.1117L112.606 13.2157C112.872 13.1854 113.103 13.402 113.094 13.675L112.985 17.236H113.208ZM182.333 15.4283C186.108 15.4283 188.273 17.5745 188.273 28.9833C188.273 39.8273 185.998 41.8038 182.666 41.8038C178.614 41.8038 176.782 39.3194 176.782 27.7409C176.782 18.0264 178.836 15.4283 182.333 15.4283ZM182.5 13.2256C175.006 13.2256 167.457 17.8567 167.457 28.7011C167.457 39.0364 174.451 44.0074 182.5 44.0074C190.161 44.0074 197.599 39.2626 197.599 28.4185C197.599 18.1393 190.549 13.2256 182.5 13.2256ZM221.382 28.9833C221.382 17.5745 219.218 15.4283 215.443 15.4283C211.945 15.4283 209.892 18.0264 209.892 27.7409C209.892 39.3194 211.724 41.8038 215.776 41.8038C219.107 41.8038 221.382 39.8273 221.382 28.9833ZM200.565 28.7011C200.565 17.8567 208.115 13.2256 215.609 13.2256C223.658 13.2256 230.708 18.1393 230.708 28.4185C230.708 39.2626 223.27 44.0074 215.609 44.0074C207.56 44.0074 200.565 39.0364 200.565 28.7011ZM243.234 17.5745C244.954 15.7109 248.118 13.2256 251.338 13.2256C254.002 13.2256 255.883 14.6937 255.883 17.4616C255.883 20.1726 253.947 21.9186 251.782 21.9186C249.397 21.9186 248.562 20.9067 247.508 19.1559C247.175 18.5347 246.841 18.4214 246.341 18.4214C245.343 18.4214 244.066 19.1559 243.289 19.8905V42.7975C243.289 43.091 243.054 43.3288 242.766 43.3288H234.985C234.696 43.3288 234.463 43.091 234.463 42.7975V14.5683C234.463 14.3339 234.635 14.1376 234.864 14.1116L242.539 13.2351C242.854 13.1991 243.129 13.4561 243.119 13.7791L243.011 17.5745H243.234Z",
            fill: "currentColor"
        })
    });
};
var OpendoorLogoBadge = function(param) {
    var _width = param.width, width = _width === void 0 ? "14px" : _width;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "20",
        viewBox: "0 0 14 20",
        fill: "none",
        style: {
            height: "auto",
            maxWidth: "100%",
            width: width
        },
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.0652 7.72525C10.0652 2.87886 9.23666 0.869951 6.95864 0.869951C4.94968 0.869951 3.93488 2.27822 3.93488 7.16613C3.93488 11.9918 4.7219 13.9801 7.04144 13.9801C9.09177 13.9801 10.0652 12.5924 10.0652 7.72525ZM0 7.60107C0 2.15396 3.74854 0 7.08288 0C10.645 0 14 2.13332 14 7.26967C14 12.7581 10.2515 14.85 6.91711 14.85C3.35507 14.85 0 12.5718 0 7.60107ZM13.2689 19.2321C12.929 18.7812 11.6198 17.0442 11.6198 17.0442C11.4969 16.8812 11.2864 16.7829 11.0605 16.7829H2.93952C2.71362 16.7829 2.50312 16.8812 2.38028 17.0442L0.731324 19.2318C0.679012 19.3011 0.651254 19.3819 0.651254 19.4645V19.7984C0.651254 19.9098 0.741489 20 0.852838 20H13.1472C13.2585 20 13.3488 19.9098 13.3488 19.7984V19.4645C13.3488 19.3819 13.3213 19.3014 13.2689 19.2321Z",
            fill: "currentColor"
        })
    });
};


/***/ }),

/***/ 412149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ header_Header; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(135944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/@opendoor/auth-fe/dist/auth-fe.esm.js
var auth_fe_esm = __webpack_require__(395674);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Box/Box.mjs
var Box = __webpack_require__(208013);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(811163);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/utils/usePrevious.tsx

var usePrevious = function(value) {
    var ref = (0,react.useRef)();
    (0,react.useEffect)(function() {
        ref.current = value;
    });
    return ref.current;
};
/* harmony default export */ var utils_usePrevious = (usePrevious);

// EXTERNAL MODULE: ./src/helpers/observability.ts + 56 modules
var observability = __webpack_require__(977997);
// EXTERNAL MODULE: ./src/components/globals.ts
var globals = __webpack_require__(735480);
// EXTERNAL MODULE: ./src/components/shared/MenuPanel.tsx
var MenuPanel = __webpack_require__(837197);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 143 modules
var motion = __webpack_require__(750979);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/motion/MotionVariants.ts
var MotionVariants = __webpack_require__(181931);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/menu/menuAnimations.ts

var menuVariants = {
    hidden: {
        opacity: 0,
        transition: {
            ease: "linear",
            duration: 0.1,
            delay: 1
        },
        transitionEnd: {
            display: "none"
        }
    },
    visible: {
        opacity: 1,
        transition: {
            ease: "linear",
            duration: 0.1
        },
        display: "block"
    }
};
var backdropVariants = {
    hidden: {
        opacity: 0,
        transition: {
            ease: MotionVariants/* defaultEase */.vI,
            delay: 0.3,
            duration: 0.2
        }
    },
    visible: {
        opacity: 1,
        transition: {
            ease: MotionVariants/* defaultEase */.vI,
            duration: 0.2
        }
    }
};
var boxVariants = {
    hidden: {
        x: "100%",
        transition: {
            ease: MotionVariants/* defaultEase */.vI,
            duration: 0.5
        }
    },
    visible: {
        x: 0,
        transition: {
            ease: MotionVariants/* defaultEase */.vI,
            duration: 0.5
        }
    }
};
var navList = {
    hidden: {
        opacity: 0,
        x: 64,
        transition: {
            duration: 0.4,
            staggerChildren: 0.05
        }
    },
    visible: {
        opacity: 1,
        x: 0,
        transition: {
            duration: 0.4,
            staggerChildren: 0.05
        }
    }
};
var ctaVariant = {
    hidden: {
        opacity: 0,
        transition: {
            ease: "linear",
            duration: 0.3
        }
    },
    visible: {
        opacity: 1,
        transition: {
            ease: "linear",
            delay: 0.3,
            duration: 0.3
        }
    }
};

// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/trapFocus.ts
var trapFocus = __webpack_require__(392690);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(370917);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/menu/components/MenuBackdrop.tsx






var MenuBackdrop = function(param) {
    var isVisible = param.isVisible, onClick = param.onClick;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
        as: motion/* motion.div */.E.div,
        variants: backdropVariants,
        initial: "hidden",
        animate: isVisible ? "visible" : "hidden",
        exit: "hidden",
        bottom: 0,
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        "aria-hidden": "true",
        zIndex: "0",
        onClick: onClick,
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background-color:rgba(0,0,0,0.2);")
    });
};

// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 3 modules
var AnimatePresence = __webpack_require__(821190);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(147568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(197582);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Toggle/Toggle.js + 1 modules
var Toggle = __webpack_require__(950379);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(836808);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
// EXTERNAL MODULE: ./src/__generated__/protobuf/journey/data/categories/language_category.ts
var language_category = __webpack_require__(515509);
// EXTERNAL MODULE: ./src/components/helpers/types.ts
var types = __webpack_require__(139922);
// EXTERNAL MODULE: ./src/components/shared/trackers.tsx
var trackers = __webpack_require__(959431);
// EXTERNAL MODULE: ./src/helpers/getPreferredLocale.ts
var getPreferredLocale = __webpack_require__(235374);
// EXTERNAL MODULE: ./src/helpers/globals.ts
var helpers_globals = __webpack_require__(763631);
// EXTERNAL MODULE: ./src/helpers/i18n.tsx + 21 modules
var i18n = __webpack_require__(371899);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/menu/LanguageToggle.tsx













var LanguageToggle = function() {
    var trackJourneyEvent = (0,observability/* useObservability */.C3)().trackJourneyEvent;
    var anonId = (0,trackers/* getAnonymousId */.y)();
    var localeCookie = js_cookie_default().get("locale");
    var ref = (0,react.useState)(localeCookie === types/* LOCALES.SPANISH */.l.SPANISH), defaultToSpanish = ref[0], setDefaultToSpanish = ref[1];
    var ref1 = (0,react.useState)(!localeCookie), loading = ref1[0], setLoading = ref1[1];
    (0,react.useEffect)(function() {
        var loadLangPref = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var preferredLocale;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,getPreferredLocale/* determinePreferredLocale */.B)({
                                    localeFromCookie: localeCookie,
                                    anonId: anonId
                                })
                            ];
                        case 1:
                            preferredLocale = _state.sent();
                            if (preferredLocale === types/* LOCALES.SPANISH */.l.SPANISH) {
                                setDefaultToSpanish(true);
                            }
                            setLoading(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return function loadLangPref() {
                return _ref.apply(this, arguments);
            };
        }();
        loadLangPref();
    }, [
        anonId,
        localeCookie
    ]);
    (0,react.useEffect)(function() {
        if (localeCookie && i18n/* i18n.language */.ag.language !== localeCookie) {
            i18n/* i18n.changeLanguage */.ag.changeLanguage(localeCookie);
        }
    }, [
        localeCookie
    ]);
    // check for pending language toggle event and send it
    (0,react.useEffect)(function() {
        var toggledLanguage = localStorage.getItem("toggledLanguage");
        if (toggledLanguage) {
            var languageEvent = parseInt(toggledLanguage, 10);
            trackJourneyEvent("language", "selectEvent", {
                language: languageEvent
            });
            localStorage.removeItem("toggledLanguage");
        }
    }, [
        trackJourneyEvent
    ]);
    var hasInteracted = (0,react.useRef)(false);
    var handleToggle = function(nextValue) {
        if (!hasInteracted.current) {
            hasInteracted.current = true;
            return; // skip the first toggle caused by initial state
        }
        var selectedLocale = nextValue ? types/* LOCALES.SPANISH */.l.SPANISH : types/* LOCALES.ENGLISH */.l.ENGLISH;
        i18n/* i18n.changeLanguage */.ag.changeLanguage(selectedLocale);
        (0,trackers/* setCookie */.d)("locale", selectedLocale, 365);
        var languageEvent = selectedLocale === types/* LOCALES.SPANISH */.l.SPANISH ? language_category/* LanguageCategory_Language.SPANISH */.hz.SPANISH : language_category/* LanguageCategory_Language.ENGLISH */.hz.ENGLISH;
        // store the language event in localStorage to send after reload
        localStorage.setItem("toggledLanguage", languageEvent.toString());
        // reload so we invoke routing to language-specific landing page in Cloudflare
        window.location.reload();
    };
    if (loading) return null;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Toggle/* Toggle */.Z, {
        size: "large",
        onCheckedChange: handleToggle,
        defaultChecked: defaultToSpanish,
        leftLabel: "English",
        rightLabel: "Spanish"
    });
};

// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box_Box = __webpack_require__(646523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Link/Link.js
var Link = __webpack_require__(422470);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/menu/components/MenuLinkItem.tsx




var MenuLinkItem = function(param) {
    var href = param.href, name = param.name, analyticsName = param.analyticsName, isActive = param.isActive, showOnTablet = param.showOnTablet, tabletDisplay = param.tabletDisplay;
    var displayValue = showOnTablet ? [
        "flex",
        null,
        tabletDisplay,
        "none"
    ] : undefined;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box_Box/* Box */.x, {
        tag: motion/* motion.li */.E.li,
        marginBottom: "$8x",
        display: displayValue,
        $largerThanSM: {
            display: "none"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
            "aria-current": isActive,
            href: href,
            "aria-label": "View link",
            analyticsName: analyticsName,
            display: "inline-flex",
            alignItems: "center",
            fontWeight: "$medium",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "span",
                typography: "$subheaderMedium",
                fontWeight: "$medium",
                $smallerThanLG: {
                    typography: "$subheaderXsmall"
                },
                children: name
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./src/components/shared/EiChevronDownIcon.tsx
var EiChevronDownIcon = __webpack_require__(887098);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/menu/mobile/MobileMegaNavButton.tsx







var MobileMegaNavButton = function(param) {
    var itemName = param.itemName, onClick = param.onClick;
    var buttonProps = {
        onPress: onClick
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box_Box/* Box */.x, {
        tag: motion/* motion.li */.E.li,
        marginBottom: "$8x",
        $largerThanSM: {
            display: "none"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box_Box/* Box */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            tag: "button"
        }, buttonProps), {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            padding: 0,
            width: "100%",
            cursor: "pointer",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                    tag: "span",
                    typography: "$subheaderMedium",
                    fontWeight: "$medium",
                    $smallerThanLG: {
                        typography: "$subheaderXsmall"
                    },
                    children: itemName
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box_Box/* Box */.x, {
                    width: 16,
                    height: 16,
                    style: {
                        transform: "rotate(-90deg)"
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EiChevronDownIcon/* EiChevronDownIcon */.O, {})
                })
            ]
        }))
    });
};

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/menu/mobile/MobileMenuList.tsx





var mainMenuVariants = {
    hidden: {
        x: "-100%",
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        transition: {
            duration: 0.3,
            ease: "easeInOut"
        }
    },
    visible: {
        x: 0,
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        transition: {
            duration: 0.3,
            ease: "easeInOut"
        }
    }
};
var MobileMenuList = function(param) {
    var megaNavData = param.megaNavData, menuPanelNavLinks = param.menuPanelNavLinks, mainNavLinks = param.mainNavLinks, slug = param.slug, tabletDisplay = param.tabletDisplay, onSubMenuOpen = param.onSubMenuOpen;
    if (megaNavData) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(motion/* motion.div */.E.div, {
            initial: "visible",
            animate: "visible",
            exit: "hidden",
            variants: mainMenuVariants,
            style: {
                overflowY: "auto",
                overflowX: "hidden"
            },
            children: [
                megaNavData.map(function(item, idx) {
                    var hasSections = item.sections && item.sections.length > 0;
                    if (hasSections) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileMegaNavButton, {
                            itemName: item.name,
                            onClick: function() {
                                return onSubMenuOpen(item.name);
                            }
                        }, "mega-".concat(idx));
                    }
                    // For items without sections (like Agents), render as a simple link
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuLinkItem, {
                        href: item.href,
                        name: item.name,
                        analyticsName: "cosmos-mega-nav-mobile-".concat(item.name.toLowerCase()),
                        isActive: slug === item.href,
                        showOnTablet: true,
                        tabletDisplay: "flex"
                    }, "mega-".concat(idx));
                }),
                menuPanelNavLinks === null || menuPanelNavLinks === void 0 ? void 0 : menuPanelNavLinks.map(function(link, idx) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuLinkItem, {
                        href: link.href,
                        name: link.name,
                        analyticsName: "cosmos-landing-page-v2-menu-link-".concat(link.name),
                        isActive: slug === link.href,
                        showOnTablet: true,
                        tabletDisplay: "flex"
                    }, "panel-".concat(idx));
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            mainNavLinks.map(function(nav, idx) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuLinkItem, {
                    href: nav.href,
                    name: nav.name,
                    analyticsName: "cosmos-landing-page-v2-nav-link-".concat(nav.name),
                    isActive: slug === nav.href,
                    showOnTablet: true,
                    tabletDisplay: tabletDisplay
                }, "main-".concat(idx));
            }),
            menuPanelNavLinks === null || menuPanelNavLinks === void 0 ? void 0 : menuPanelNavLinks.map(function(link, idx) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuLinkItem, {
                    href: link.href,
                    name: link.name,
                    analyticsName: "cosmos-landing-page-v2-menu-link-".concat(link.name),
                    isActive: slug === link.href
                }, "panel-".concat(idx));
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/menu/mobile/MobileSubMenuBackButton.tsx






var MobileSubMenuBackButton = function(param) {
    var onClick = param.onClick;
    var buttonProps = {
        onPress: onClick
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box_Box/* Box */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, buttonProps), {
        tag: "button",
        alignItems: "left",
        cursor: "pointer",
        style: {
            transform: "rotate(90deg)"
        },
        marginBottom: "$16x",
        padding: 0,
        width: 16,
        height: 16,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EiChevronDownIcon/* EiChevronDownIcon */.O, {})
    }));
};

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/menu/mobile/MobileSubMenuSection.tsx




var MobileSubMenuSection = function(param) {
    var section = param.section, parentName = param.parentName;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box_Box/* Box */.x, {
        marginBottom: "$8x",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "h3",
                typography: "$labelMedium",
                fontWeight: "$medium",
                marginBottom: "$8x",
                children: section.title
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box_Box/* Box */.x, {
                display: "flex",
                flexDirection: "column",
                gap: "$4x",
                children: section.links.map(function(link, linkIdx) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box_Box/* Box */.x, {
                        tag: motion/* motion.li */.E.li,
                        marginBottom: "$8x",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                            href: link.href,
                            textDecorationLine: "none",
                            "aria-label": "Navigate to ".concat(link.name),
                            analyticsName: "cosmos-mega-nav-mobile-".concat(parentName.toLowerCase(), "-").concat(link.name.toLowerCase().replace(/\s+/g, "-")),
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "span",
                                typography: "$subheaderSmall",
                                fontWeight: "$medium",
                                color: "$contentPrimary",
                                $smallerThanLG: {
                                    typography: "$subheaderXsmall"
                                },
                                children: link.name
                            })
                        })
                    }, linkIdx);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/menu/mobile/MobileMenuSubMenu.tsx





var subMenuVariants = {
    hidden: {
        x: "100%",
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        transition: {
            duration: 0.3,
            ease: "easeInOut"
        }
    },
    visible: {
        x: 0,
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        transition: {
            duration: 0.3,
            ease: "easeInOut"
        }
    }
};
var MobileMenuSubMenu = function(param) {
    var megaNavData = param.megaNavData, openSubMenu = param.openSubMenu, navList = param.navList, onBack = param.onBack;
    var ref;
    var currentItem = megaNavData.find(function(item) {
        return item.name === openSubMenu;
    });
    if (!currentItem) return null;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(motion/* motion.div */.E.div, {
        initial: "hidden",
        animate: "visible",
        exit: "hidden",
        variants: subMenuVariants,
        style: {
            overflowY: "auto",
            overflowX: "hidden"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileSubMenuBackButton, {
                onClick: onBack
            }),
            (ref = currentItem.sections) === null || ref === void 0 ? void 0 : ref.map(function(section, sectionIdx) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileSubMenuSection, {
                    section: section,
                    parentName: openSubMenu,
                    navList: navList
                }, sectionIdx);
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Link/Link.mjs
var Link_Link = __webpack_require__(847208);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Text/Text.mjs
var Text_Text = __webpack_require__(4796);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/menu/components/MenuCTA.tsx





var MenuCTA = function(param) {
    var ctaLink = param.ctaLink, ctaTitle = param.ctaTitle, animate = param.animate;
    if (!(ctaLink === null || ctaLink === void 0 ? void 0 : ctaLink.name) || !(ctaLink === null || ctaLink === void 0 ? void 0 : ctaLink.href)) return null;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
        as: motion/* motion.div */.E.div,
        variants: ctaVariant,
        animate: animate,
        gridColumn: "1",
        gridRow: "3",
        pt: [
            7,
            null,
            9
        ],
        w: "100%",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Link_Link/* default */.Z, {
            href: ctaLink.href,
            "aria-label": "",
            analyticsName: "cosmos-landing-page-v2-menu-cta-link-".concat(ctaLink.name),
            backgroundColor: "blue50",
            borderRadius: "semiRounded",
            color: "warmgrey950",
            display: "block",
            fontWeight: "medium",
            p: "16px",
            _hover: {
                color: "brandBlue600"
            },
            children: [
                ctaTitle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text_Text/* default */.Z, {
                    as: "span",
                    display: "block",
                    size: "90",
                    fontWeight: "inherit",
                    children: ctaTitle
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text_Text/* default */.Z, {
                    as: "span",
                    color: "inherit",
                    display: "block",
                    size: "110",
                    fontWeight: "inherit",
                    children: ctaLink.name
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/menu/components/MenuContent.tsx










var MenuContent = function(param) {
    var isVisible = param.isVisible, containerRef = param.containerRef, onAnimationComplete = param.onAnimationComplete, slug = param.slug, menuPanelNavLinks = param.menuPanelNavLinks, mainNavLinks = param.mainNavLinks, ctaLink = param.ctaLink, ctaTitle = param.ctaTitle, displayLanguageToggle = param.displayLanguageToggle, megaNavData = param.megaNavData;
    var animate = isVisible ? "visible" : "hidden";
    var ref = (0,react.useState)(null), openSubMenu = ref[0], setOpenSubMenu = ref[1];
    var tabletDisplay = mainNavLinks.length > 2 ? "flex" : "none";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
        onAnimationComplete: onAnimationComplete,
        as: motion/* motion.div */.E.div,
        variants: boxVariants,
        initial: "hidden",
        animate: isVisible ? "visible" : "hidden",
        exit: "hidden",
        tabIndex: -1,
        ref: containerRef,
        backgroundColor: "white0",
        gridArea: "1 / 1 / -1 / -1",
        pt: [
            200,
            168,
            168
        ],
        pl: [
            7,
            null,
            10
        ],
        pr: [
            7,
            null,
            10
        ],
        pb: [
            7,
            null,
            10
        ],
        maxW: [
            "100%",
            null,
            "424px"
        ],
        bottom: "0px",
        left: [
            0,
            null,
            "auto"
        ],
        right: "0",
        position: "fixed",
        top: "0px",
        w: "100%",
        zIndex: "10",
        role: "dialog",
        "aria-labelledby": "dialog-main-menu",
        "aria-modal": "true",
        display: "grid",
        gridTemplateRows: "1fr auto auto",
        gridTemplateColumns: "1fr",
        overflow: "auto",
        outline: "0",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("overscroll-behavior-y:contain;"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                as: motion/* motion.ul */.E.ul,
                animate: animate,
                variants: navList,
                gridColumn: "1",
                gridRow: "1",
                m: "0",
                p: "0",
                role: "list",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("list-style:none;position:relative;overflow-y:auto;overflow-x:hidden;"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatePresence/* AnimatePresence */.M, {
                    initial: false,
                    children: megaNavData && openSubMenu ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileMenuSubMenu, {
                        megaNavData: megaNavData,
                        openSubMenu: openSubMenu,
                        navList: navList,
                        onBack: function() {
                            return setOpenSubMenu(null);
                        }
                    }, "submenu") : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileMenuList, {
                        megaNavData: megaNavData,
                        menuPanelNavLinks: menuPanelNavLinks,
                        mainNavLinks: mainNavLinks,
                        slug: slug,
                        tabletDisplay: tabletDisplay,
                        onSubMenuOpen: function(itemName) {
                            return setOpenSubMenu(itemName);
                        }
                    }, "mainmenu")
                })
            }),
            displayLanguageToggle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                gridColumn: "1",
                gridRow: "2",
                alignSelf: "end",
                display: "flex",
                justifyContent: "flex-start",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LanguageToggle, {})
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuCTA, {
                ctaLink: ctaLink,
                ctaTitle: ctaTitle,
                animate: animate
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/menu/MenuPanel.tsx








var Menu = function(param) {
    var slug = param.slug, menuPanelNavLinks = param.menuPanelNavLinks, mainNavLinks = param.mainNavLinks, ctaLink = param.ctaLink, ctaTitle = param.ctaTitle, isVisible = param.isVisible, setIsVisible = param.setIsVisible, exitComplete = param.exitComplete, showLanguageToggle = param.showLanguageToggle, megaNavData = param.megaNavData;
    var containerRef = (0,react.useRef)(null);
    var animate = isVisible ? "visible" : "hidden";
    var onComplete = function(definition) {
        if (definition === "visible") {
            var ref;
            (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.focus();
        } else {
            exitComplete();
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
        as: motion/* motion.div */.E.div,
        variants: menuVariants,
        animate: animate,
        onKeyDown: function(e) {
            return (0,trapFocus/* trapFocus */.S)(e, containerRef);
        },
        bottom: 0,
        display: "grid",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuContent, {
                isVisible: !!isVisible,
                containerRef: containerRef,
                onAnimationComplete: onComplete,
                slug: slug,
                menuPanelNavLinks: menuPanelNavLinks,
                mainNavLinks: mainNavLinks,
                ctaLink: ctaLink,
                ctaTitle: ctaTitle,
                displayLanguageToggle: showLanguageToggle,
                megaNavData: megaNavData
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuBackdrop, {
                isVisible: !!isVisible,
                onClick: function() {
                    return setIsVisible(false);
                }
            })
        ]
    });
};
var MenuPanel_MenuPanel = function(param) {
    var slug = param.slug, menuPanelNavLinks = param.menuPanelNavLinks, mainNavLinks = param.mainNavLinks, ctaLink = param.ctaLink, ctaTitle = param.ctaTitle, isVisible = param.isVisible, setIsVisible = param.setIsVisible, exitComplete = param.exitComplete, showLanguageToggle = param.showLanguageToggle, megaNavData = param.megaNavData;
    var ref = (0,react.useState)(false), mounted = ref[0], setMounted = ref[1];
    (0,react.useEffect)(function() {
        return setMounted(true);
    }, []);
    (0,react.useEffect)(function() {
        document.body.classList.toggle("has-sheet", isVisible);
    }, [
        isVisible
    ]);
    var escFunction = (0,react.useCallback)(function(event) {
        if (event.key === "Escape") {
            setIsVisible(false);
        }
    }, []);
    (0,react.useEffect)(function() {
        document.addEventListener("keydown", escFunction, false);
        return function() {
            document.removeEventListener("keydown", escFunction, false);
        };
    }, [
        escFunction
    ]);
    return mounted ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Menu, {
        slug: slug,
        menuPanelNavLinks: menuPanelNavLinks,
        mainNavLinks: mainNavLinks,
        ctaLink: ctaLink,
        ctaTitle: ctaTitle,
        isVisible: isVisible,
        setIsVisible: setIsVisible,
        exitComplete: exitComplete,
        showLanguageToggle: showLanguageToggle,
        megaNavData: megaNavData
    }) : null;
};
/* harmony default export */ var menu_MenuPanel = (MenuPanel_MenuPanel);

// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/PressableBox.js
var PressableBox = __webpack_require__(302267);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/__generated__/icons/ChevronDown.js
var ChevronDown = __webpack_require__(284359);
// EXTERNAL MODULE: ./src/components/account/AccountMenu.tsx + 1 modules
var AccountMenu = __webpack_require__(88594);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/header/LoginSection.tsx




var LoginSection = function(param) {
    var showLogin = param.showLogin;
    var t = (0,i18n/* useT */.NT)().t;
    if (!showLogin) return null;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
        href: "#",
        fontWeight: "$medium",
        analyticsName: "cosmos-sign-in",
        "aria-label": "Sign in to your account",
        color: "$contentPrimary",
        children: t("homepage.titles.signIn", "Sign in")
    });
};

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/header/AccountSection.tsx








var AccountSection = function(param) {
    var isLoggedIn = param.isLoggedIn, showLogin = param.showLogin, firstName = param.firstName, initials = param.initials, isExpanded = param.isExpanded, handleAccountClick = param.handleAccountClick;
    var t = (0,i18n/* useT */.NT)().t;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PressableBox/* PressableBox */.K, {
        onPress: handleAccountClick,
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        "aria-label": "Account menu",
        analyticsName: "account-section-click",
        children: isLoggedIn ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PressableBox/* PressableBox */.K, {
            display: "inline-flex",
            cursor: "pointer",
            gap: "$1x",
            "aria-label": "User account menu",
            analyticsName: "user-account-menu-click",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box_Box/* Box */.x, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                            tag: "span",
                            $smallerThanMD: {
                                display: "none"
                            },
                            typography: "$labelMedium",
                            color: "$contentPrimary",
                            hoverStyle: {
                                color: "$backgroundAccentBrand"
                            },
                            children: [
                                t("homepage.titles.welcome", "Welcome"),
                                " ",
                                firstName
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                            tag: "span",
                            typography: "$labelSmall",
                            $largerThanSM: {
                                display: "none"
                            },
                            borderRadius: "$60x",
                            backgroundColor: "$backgroundInversePrimary",
                            color: "$contentInversePrimary",
                            p: "$2x",
                            children: initials
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box_Box/* Box */.x, {
                    width: 24,
                    height: 24,
                    position: "relative",
                    $smallerThanMD: {
                        top: 3
                    },
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    style: {
                        transition: "0.15s ".concat(MotionVariants/* defaultEaseCss */.qc, " transform"),
                        transform: isExpanded ? "rotate(180deg)" : "rotate(0)",
                        transformOrigin: "center"
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChevronDown/* default */.Z, {
                        size: 20,
                        color: "$contentPrimary"
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box_Box/* Box */.x, {
                    position: "absolute",
                    top: -35,
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("right:-35px;@media (max-width:1201px){right:-30px;}@media (max-width:767px){right:-20px;left:inherit;}"),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccountMenu/* default */.Z, {
                        isExpanded: isExpanded
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoginSection, {
            showLogin: showLogin
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Button/Button.mjs
var Button = __webpack_require__(726029);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/header/GlobalNavSVG.tsx
/*
  Saves us from making a network request to https://images.opendoor.com/source/s3/imgdrop-production/2023-06-1687822944103-28395.svg?preset=square-2048

*/ 

var GlobalNavSVG = function(param) {
    var isOpen = param.isOpen;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
        className: isOpen ? "is-open" : undefined,
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(".menu-bar-top,.menu-bar-bottom{transform-origin:center;transition:transform 0.3s cubic-bezier(0.55,0,0.15,1);}.menu-bar-top{transform:translateY(-4px);}.menu-bar-bottom{transform:translateY(4px);}&.is-open .menu-bar-top{transform:rotate(45deg);}&.is-open .menu-bar-bottom{transform:rotate(-45deg);}"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                className: "menu-bar-top",
                d: "M4 12H20",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                className: "menu-bar-bottom",
                d: "M4 12H20",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/header/HeaderMenuButton.tsx




var HeaderMenuButton = function(param) {
    var navMenuId = param.navMenuId, navMenuButtonId = param.navMenuButtonId, isVisible = param.isVisible, handleMenuClick = param.handleMenuClick, ctaRef = param.ctaRef;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.ZP, {
        analyticsName: "cosmos-landing-page-header-menu-button",
        "aria-label": "Navigation menu",
        "aria-controls": navMenuId,
        "aria-expanded": isVisible ? "true" : "false",
        "aria-haspopup": "true",
        id: navMenuButtonId,
        ref: ctaRef,
        border: 0,
        color: "warmgrey950",
        height: "24px",
        minHeight: "24px",
        width: "24px",
        p: 0,
        outline: "0",
        onClick: handleMenuClick,
        _hover: {
            borderRadius: "roundedSquare",
            color: "brandBlue600"
        },
        _active: {
            borderRadius: "roundedSquare",
            scale: 1
        },
        _focus: {
            borderRadius: "roundedSquare",
            color: "warmgrey950",
            outline: 0
        },
        _focusVisible: {
            borderRadius: "roundedSquare",
            color: "brandBlue600",
            outline: 0
        },
        style: {
            background: "none",
            borderRadius: "roundedSquare"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GlobalNavSVG, {
            isOpen: isVisible
        })
    });
};

// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/OpendoorLogo.tsx
var OpendoorLogo = __webpack_require__(708222);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/header/LogoSection.tsx




var LogoSection = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box_Box/* Box */.x, {
        gridColumn: "1 / 2",
        gridRow: "1 / 2",
        pr: "$4x",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        zIndex: 5,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                color: "$contentPrimary",
                href: "/",
                analyticsName: "cosmos-logo-link",
                "aria-label": "Go to Home page",
                $smallerThanMD: {
                    display: "none"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OpendoorLogo/* OpendoorLogo */.o, {
                    width: "96px"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                color: "$contentPrimary",
                href: "/",
                analyticsName: "cosmos-logo-link",
                "aria-label": "Go to Home page",
                $largerThanSM: {
                    display: "none"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OpendoorLogo/* OpendoorLogoBadge */.j, {})
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/index.mjs + 34 modules
var novo = __webpack_require__(481821);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/header/MegaNavFlyout.tsx





var flyoutVariants = {
    hidden: {
        opacity: 0,
        y: -10,
        transition: {
            duration: 0.2,
            ease: "easeOut"
        }
    },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.2,
            ease: "easeOut"
        }
    }
};
var MegaNavFlyout = function(param) {
    var item = param.item, isVisible = param.isVisible, onMouseEnter = param.onMouseEnter, onMouseLeave = param.onMouseLeave, topOffset = param.topOffset;
    var ref;
    var ref1 = (0,react.useState)(false), isAnimationComplete = ref1[0], setIsAnimationComplete = ref1[1];
    // Reset animation complete state when visibility changes
    (0,react.useEffect)(function() {
        if (!isVisible) {
            setIsAnimationComplete(false);
        }
    }, [
        isVisible
    ]);
    var handleAnimationComplete = function(definition) {
        if (definition === "visible") {
            setIsAnimationComplete(true);
        }
    };
    // Only enable mouse events after the open animation completes
    var enableMouseEvents = isVisible && isAnimationComplete;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion/* motion.div */.E.div, {
        initial: "hidden",
        animate: isVisible ? "visible" : "hidden",
        variants: flyoutVariants,
        onAnimationComplete: handleAnimationComplete,
        onMouseEnter: enableMouseEvents ? onMouseEnter : undefined,
        onMouseLeave: enableMouseEvents ? onMouseLeave : undefined,
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:fixed;top:", topOffset, "px;left:0;width:100vw;background:white;box-shadow:0 4px 6px -1px rgba(0,0,0,0.1),0 2px 4px -1px rgba(0,0,0,0.06);z-index:1000;padding:32px 0;/* Always render in HTML for SEO,but control visibility with CSS */\n        opacity:", isVisible ? 1 : 0, ";visibility:", isVisible ? "visible" : "hidden", ";pointer-events:", isVisible ? "auto" : "none", ";"),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box_Box/* Box */.x, {
            width: "100%",
            paddingHorizontal: "$11x",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box_Box/* Box */.x, {
                display: "flex",
                flexDirection: "row",
                gap: 180,
                justifyContent: "center",
                children: (ref = item.sections) === null || ref === void 0 ? void 0 : ref.map(function(section, sectionIndex) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box_Box/* Box */.x, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "p",
                                typography: "$bodyMedium",
                                fontWeight: "$medium",
                                marginBottom: "$4x",
                                children: section.title
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box_Box/* Box */.x, {
                                display: "flex",
                                flexDirection: "column",
                                gap: "$3x",
                                children: section.links.map(function(link, linkIndex) {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                                        href: link.href,
                                        size: "medium",
                                        variant: "secondary",
                                        textDecorationLine: "none",
                                        "aria-label": "Navigate to ".concat(link.name),
                                        analyticsName: "cosmos-mega-nav-".concat(item.name.toLowerCase(), "-").concat(link.name.toLowerCase().replace(/\s+/g, "-")),
                                        children: link.name
                                    }, linkIndex);
                                })
                            })
                        ]
                    }, sectionIndex);
                })
            })
        })
    });
};
/* harmony default export */ var header_MegaNavFlyout = (MegaNavFlyout);

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/header/NavLink.tsx



var headerHeight = "72px";
var NavLink = function(param) {
    var children = param.children, name = param.name, href = param.href, active = param.active;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link_Link/* default */.Z, {
        alignItems: "center",
        color: "warmgrey950",
        display: "inline-flex",
        lineHeight: "100",
        fontWeight: "medium",
        py: 3,
        px: 5,
        h: headerHeight,
        analyticsName: "cosmos-landing-page-v2-nav-link-".concat(name),
        "aria-label": "View link",
        href: href,
        "aria-current": active,
        children: children
    });
};

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/header/MegaNav.tsx








var HEADER_HEIGHT = "72px";
var MegaNav = function(param) {
    var slug = param.slug, megaNavData = param.megaNavData;
    var ref = (0,react.useState)(null), openNavItem = ref[0], setOpenNavItem = ref[1];
    var ref1 = (0,react.useState)(72), flyoutTopOffset = ref1[0], setFlyoutTopOffset = ref1[1];
    var navRef = (0,react.useRef)(null);
    var closeTimerRef = (0,react.useRef)(null);
    var handleMouseEnter = function(itemName) {
        if (closeTimerRef.current) {
            clearTimeout(closeTimerRef.current);
            closeTimerRef.current = null;
        }
        // Calculate the flyout top position based on where the nav actually is in the viewport
        // This accounts for any banners or other elements above the header
        if (navRef.current) {
            var rect = navRef.current.getBoundingClientRect();
            setFlyoutTopOffset(rect.bottom);
        }
        setOpenNavItem(itemName);
    };
    var handleMouseLeave = function() {
        if (closeTimerRef.current) {
            clearTimeout(closeTimerRef.current);
        }
        closeTimerRef.current = setTimeout(function() {
            setOpenNavItem(null);
            closeTimerRef.current = null;
        }, 400);
    };
    (0,react.useEffect)(function() {
        var handleClickOutside = function(event) {
            if (navRef.current && !navRef.current.contains(event.target)) {
                setOpenNavItem(null);
            }
        };
        if (openNavItem) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        openNavItem
    ]);
    (0,react.useEffect)(function() {
        return function() {
            if (closeTimerRef.current) {
                clearTimeout(closeTimerRef.current);
            }
        };
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
        ref: navRef,
        gridColumn: "1 / -1",
        gridRow: "1 / 2",
        position: "relative",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
            as: "ul",
            m: "0",
            p: "0",
            display: [
                "none",
                null,
                "flex"
            ],
            justifyContent: "center",
            analyticsName: "cosmos-mega-nav-menu-list",
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("list-style:none;"),
            children: megaNavData === null || megaNavData === void 0 ? void 0 : megaNavData.map(function(navItem) {
                var isOpen = openNavItem === navItem.name;
                var hasSections = navItem.sections && navItem.sections.length > 0;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                    as: "li",
                    position: "relative",
                    onMouseEnter: hasSections ? function() {
                        return handleMouseEnter(navItem.name);
                    } : undefined,
                    onMouseLeave: hasSections ? handleMouseLeave : undefined,
                    children: hasSections ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MegaNavLink, {
                                active: slug === navItem.href,
                                href: navItem.href,
                                name: navItem.name,
                                isOpen: isOpen,
                                children: navItem.name
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(header_MegaNavFlyout, {
                                item: navItem,
                                isVisible: isOpen,
                                onMouseEnter: function() {
                                    return handleMouseEnter(navItem.name);
                                },
                                onMouseLeave: handleMouseLeave,
                                topOffset: flyoutTopOffset
                            })
                        ]
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavLink, {
                        active: slug === navItem.href,
                        href: navItem.href,
                        name: navItem.name,
                        children: navItem.name
                    })
                }, navItem.name);
            })
        })
    });
};
var MegaNavLink = function(param) {
    var children = param.children, name = param.name, active = param.active, isOpen = param.isOpen, href = param.href;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
        as: "a",
        href: href,
        display: "inline-flex",
        alignItems: "center",
        lineHeight: "100",
        fontWeight: "medium",
        py: 3,
        px: 5,
        h: HEADER_HEIGHT,
        "aria-label": "View link",
        "aria-current": active,
        "aria-expanded": isOpen,
        analyticsName: "cosmos-mega-nav-v2-nav-link-".concat(name),
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background:transparent;border:none;cursor:pointer;color:", novo/* novo.colors.warmgrey950 */.hI.colors.warmgrey950, ";text-decoration:none;gap:8px;&:hover,&:focus{color:", novo/* novo.colors.brandBlue600 */.hI.colors.brandBlue600, ";outline:0;}&:active{color:", novo/* novo.colors.brandBlue600 */.hI.colors.brandBlue600, ";}"),
        children: [
            children,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: "0.6em",
                height: "0.6em",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("transition:transform 0.2s ease;transform:", isOpen ? "rotate(180deg)" : "rotate(0deg)", ";"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EiChevronDownIcon/* EiChevronDownIcon */.O, {})
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/header/SkipLink.tsx



var SkipLink = function(_props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.ZP, {
        border: 0,
        color: "brand50",
        justifyContent: "center",
        left: 0,
        outline: 0,
        position: "fixed",
        top: "0",
        transform: "translateY(-100%)",
        width: "100%",
        zIndex: 1,
        display: "flex",
        backgroundColor: "neutrals0",
        "aria-label": "Skip navigation menu and view main content",
        _focus: {
            transform: "translateY(0)"
        },
        analyticsName: "cosmos-landing-page-v2-skip-to-main-content",
        onClick: function() {
            var mainElem = document.querySelector("main");
            mainElem && mainElem.focus();
        },
        children: "Skip to main content"
    });
};

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/header/Header.tsx















var redirectToLogin = function() {
    document.location.href = "".concat(globals/* COSMOS_URL */.EQ, "/login?redirectTo=").concat(encodeURIComponent(window.location.pathname));
};
var Header_headerHeight = "72px";
var Header = function(param) {
    var slug = param.slug, menuPanelNavLinks = param.menuPanelNavLinks, mainNavLinks = param.mainNavLinks, ctaTitle = param.ctaTitle, ctaLink = param.ctaLink, showLanguageToggle = param.showLanguageToggle, megaNavDataProp = param.megaNavData;
    var pathname = (0,router.useRouter)().pathname;
    var navMenuButtonId = MenuPanel/* DEFAULT_NAV_MENU_BUTTON_ID */.Q7;
    var navMenuId = MenuPanel/* DEFAULT_NAV_MENU_ID */.KB;
    var trackEvent = (0,observability/* useObservability */.C3)().trackEvent;
    var ref = (0,react.useState)(false), isExpanded = ref[0], setExpanded = ref[1];
    var ref1 = (0,auth_fe_esm/* useAuth */.aC)(), human = ref1.user, authentication = ref1.authentication;
    var isLoggedIn = authentication.state === "authenticated";
    var fullName = human === null || human === void 0 ? void 0 : human.fullName;
    var firstName = fullName ? fullName.split(" ")[0] : "";
    var initials = fullName ? fullName.split(" ").map(function(n) {
        return n[0];
    }) : [];
    var ref2 = (0,react.useState)(false), isVisible = ref2[0], setIsVisible = ref2[1];
    var prevVisible = utils_usePrevious(isVisible);
    var toggleMenuOpen = function() {
        return setIsVisible(!isVisible);
    };
    var handleMenuClick = function() {
        // TODO: remove categoryOverride
        // observability is initialized with 'cosmos' as the category for all events
        trackEvent("cta-click", "menu", undefined, {
            categoryOverride: "homepage"
        });
        toggleMenuOpen();
    };
    var handleAccountClick = function() {
        // TODO: remove categoryOverride
        // observability is initialized with 'cosmos' as the category for all events
        trackEvent("cta-click", "account-icon", undefined, {
            categoryOverride: "homepage"
        });
        authentication.state === "authenticated" ? setExpanded(!isExpanded) : redirectToLogin();
    };
    // Hang on to burger button ref for focus management
    var ctaRef = (0,react.useRef)(null);
    // When menu close animation is complete
    // and it was previously open.
    // This prevents a focus from the initial animation state
    // on page load.
    var exitComplete = function() {
        if (prevVisible === true) {
            var ref;
            (ref = ctaRef.current) === null || ref === void 0 ? void 0 : ref.focus();
        }
    };
    //Hide Sign button on the sign in page
    var showLogin = !(pathname.includes("/login") || pathname.includes("/account"));
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(menu_MenuPanel, {
                slug: slug,
                menuPanelNavLinks: menuPanelNavLinks,
                mainNavLinks: mainNavLinks,
                ctaTitle: ctaTitle,
                ctaLink: ctaLink,
                isVisible: isVisible,
                setIsVisible: setIsVisible,
                exitComplete: exitComplete,
                showLanguageToggle: showLanguageToggle,
                megaNavData: megaNavDataProp
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                background: "white0",
                h: Header_headerHeight,
                position: "sticky",
                top: "0",
                zIndex: "2000",
                pl: [
                    20,
                    null,
                    0
                ],
                pr: [
                    20,
                    null,
                    0
                ],
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
                    display: "grid",
                    gridTemplateColumns: "auto 1fr auto",
                    h: Header_headerHeight,
                    marginX: "auto",
                    px: [
                        null,
                        null,
                        9,
                        11,
                        11
                    ],
                    maxW: "1440px",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SkipLink, {}),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoSection, {}),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MegaNav, {
                            slug: slug,
                            mainNavLinks: mainNavLinks,
                            megaNavData: megaNavDataProp
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
                            display: "flex",
                            gridRow: "1 / 2",
                            gridColumn: "-1 / -2",
                            alignItems: "center",
                            gap: "24px",
                            pl: "16px",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccountSection, {
                                    isLoggedIn: isLoggedIn,
                                    showLogin: showLogin,
                                    firstName: firstName,
                                    initials: initials,
                                    isExpanded: isExpanded,
                                    handleAccountClick: handleAccountClick
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeaderMenuButton, {
                                        navMenuId: navMenuId,
                                        navMenuButtonId: navMenuButtonId,
                                        isVisible: isVisible,
                                        handleMenuClick: handleMenuClick,
                                        ctaRef: ctaRef
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var header_Header = (Header);


/***/ }),

/***/ 235374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ determinePreferredLocale; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(147568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(197582);
/* harmony import */ var _generated_protobuf_journey_data_categories_language_category__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(515509);
/* harmony import */ var components_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(567945);
/* harmony import */ var components_helpers_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(139922);





function determinePreferredLocale(_) {
    return _determinePreferredLocale.apply(this, arguments);
}
function _determinePreferredLocale() {
    _determinePreferredLocale = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var localeFromCookie, anonId, ref, ref1, ref2, ref3, ref4, ref5, result, traitValue;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    localeFromCookie = param.localeFromCookie, anonId = param.anonId;
                    if (localeFromCookie === components_helpers_types__WEBPACK_IMPORTED_MODULE_2__/* .LOCALES.SPANISH */ .l.SPANISH || localeFromCookie === components_helpers_types__WEBPACK_IMPORTED_MODULE_2__/* .LOCALES.ENGLISH */ .l.ENGLISH) {
                        return [
                            2,
                            localeFromCookie
                        ];
                    }
                    return [
                        4,
                        (0,components_api__WEBPACK_IMPORTED_MODULE_1__/* .fetchTraitByAnonymousId */ .I6)("language_preference", anonId)
                    ];
                case 1:
                    result = _state.sent();
                    traitValue = result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : (ref1 = ref.insightV2) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.getTraitForIdentifier) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.trait) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.value) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.kind) === null || ref5 === void 0 ? void 0 : ref5.stringValue;
                    if (traitValue === _generated_protobuf_journey_data_categories_language_category__WEBPACK_IMPORTED_MODULE_0__/* .LanguageCategory_Language.SPANISH */ .hz.SPANISH) return [
                        2,
                        components_helpers_types__WEBPACK_IMPORTED_MODULE_2__/* .LOCALES.SPANISH */ .l.SPANISH
                    ];
                    if (traitValue === _generated_protobuf_journey_data_categories_language_category__WEBPACK_IMPORTED_MODULE_0__/* .LanguageCategory_Language.ENGLISH */ .hz.ENGLISH) return [
                        2,
                        components_helpers_types__WEBPACK_IMPORTED_MODULE_2__/* .LOCALES.ENGLISH */ .l.ENGLISH
                    ];
                    return [
                        2,
                        null
                    ];
            }
        });
    });
    return _determinePreferredLocale.apply(this, arguments);
}


/***/ }),

/***/ 763631:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A4": function() { return /* binding */ MAPBOX_ACCESS_TOKEN; },
/* harmony export */   "HP": function() { return /* binding */ OD_APP_URL; },
/* harmony export */   "Hx": function() { return /* binding */ MAPBOX_MAP_STYLE; },
/* harmony export */   "j_": function() { return /* binding */ HOMEPAGE_URL; }
/* harmony export */ });
/* harmony import */ var _opendoor_shared_fe_build_railsEnv__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(127825);
/* provided dependency */ var process = __webpack_require__(734155);
var ref;

var railsEnv = (0,_opendoor_shared_fe_build_railsEnv__WEBPACK_IMPORTED_MODULE_0__.getRailsEnv)();
var useStaging = (ref = process.env.REACT_APP_ATHENA_URL) === null || ref === void 0 ? void 0 : ref.includes("staging");
var env = useStaging ? "staging" : railsEnv;
var HOMEPAGE_URL = {
    production: "https://www.opendoor.com",
    staging: "https://demo.simplersell.com",
    qa: "https://demo.simplersell.com",
    development: "http://localhost:3011/homepage-2019",
    test: "https://www.opendoor.com"
}[env];
var MAPBOX_ACCESS_TOKEN = "pk.eyJ1Ijoib3BlbmRvb3IiLCJhIjoiWXJ2bTJiRSJ9.lsnjT9yTNyyVzKRIzqxnqg";
var MAPBOX_MAP_STYLE = "mapbox://styles/opendoor/cktkqasmc1gbe17pfo2cm7ybb";
var getIsIOS = function() {
    var userAgent = typeof navigator !== "undefined" && (navigator.userAgent || navigator.vendor);
    return userAgent && /iPad|iPhone|iPod/.test(userAgent);
};
var platform = getIsIOS() ? "ios" : "android";
var OD_APP_URL = {
    ios: "https://itunes.apple.com/us/app/opendoor-homes-all-day-open/id1143708068?mt=8",
    android: "https://play.google.com/store/apps/details?id=com.opendoor.buyerapp&hl=en"
}[platform];


/***/ })

}]);